import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import ImageScale from '../../components/scale/image_scale'
import css from './style.css'

const FlourescenceSection = props => {
  /** ------------------- */
  /** FLOURESCENCE SCALE  */
  /** ------------------- */

  const faint = require('./images/fluorescenceScale/faint@2x.png')
  const medium = require('./images/fluorescenceScale/medium@2x.png')
  const none = require('./images/fluorescenceScale/none@2x.png')
  const strong = require('./images/fluorescenceScale/strong@2x.png')
  const veryStrong = require('./images/fluorescenceScale/very-strong@2x.png')

  const flourescenceScale = [
    {
      elements: [
        { img: none, name: 'None' },
        { img: faint, name: 'Faint' },
        { img: medium, name: 'Medium' },
        { img: strong, name: 'Strong' },
        { img: veryStrong, name: 'Very Strong' }
      ]
    }
  ]
  return (
    <div>
      <Grid>
        <div className={css.pinkBg3} />
        <GridItem col='5/10' customStyle={[css.gridItem, 'center'].join(' ')}>
          <img className={css.imageFluorescence}
            src={require('./images/fluorescence_diamond_ring.png')}
            srcSet={[
              require('./images/fluorescence_diamond_ring.png') + ' 1x',
              require('./images/fluorescence_diamond_ring@2x.png') + ' 2x'
            ].join(', ')}
          />
        </GridItem>
        <GridItem col='5/10' customStyle={css.gridItem}>
          <div className={css.title}>
            Fluorescence
          </div>
          <p className={css.text}>
            Fluorescence is caused by a structural deformation or impurity in the diamond. A diamond with fluorescence will react negatively to UV light. Indoors under a blacklight a diamond with fluorescence will glow blue. Fluorescence doesn’t make a difference for practical reasons, but only up to a point. Some “strong” and “very strong” fluorescent diamonds react negatively to the UV light in the sun. These diamonds do not turn blue in sunlight, but they will appear milky or hazy and lose their brilliance.
          </p>
          <p className={css.text}>
            For this reason, even though strong and very strongly fluorescent diamonds are the most inexpensive diamonds you can find, it’s not worth the risk. We don’t put these into our brand at all.
          </p>
        </GridItem>
      </Grid>
      <Grid>
        <GridItem col='1/1' customStyle={css.gridItem}>
          <ImageScale elements={flourescenceScale} imgHeight={60} />
        </GridItem>
      </Grid>
    </div>
  )
}

export default FlourescenceSection



// WEBPACK FOOTER //
// ./src/containers/diamond/flourescence_section.js